import {Grid} from '@yandex-delivery/blocks'
import {HeaderButton} from '@yandex-delivery/order-layout-blocks'
import React, {useState} from 'react'

import {i18n} from '../../config'
import {desktopClasses} from './Menu.classes'

type SubMenuProps = {
  isVisible?: boolean
}

function SubDeliveryMenuDeliveryToCustomer({isVisible = false}: SubMenuProps): React.ReactElement | null {
  return isVisible ? (
    <Grid alignItems="flex-start" container>
      <Grid direction="column" container item xs>
        <Grid item>
          <HeaderButton size="s" variant="pseudo" active transparent>
            {i18n('order.header.link.around-town', 'По городу')}
          </HeaderButton>
        </Grid>
        <Grid item>
          <HeaderButton href="/express-delivery/" size="s" variant="pseudo" transparent>
            {i18n('order.header.link.one-hour-delivery', 'Доставка за час')}
          </HeaderButton>
        </Grid>
        <Grid item>
          <HeaderButton href="/next-day-delivery/" size="s" variant="pseudo" transparent>
            {i18n('order.header.link.next-day-delivery', 'Доставка на следующий день')}
          </HeaderButton>
        </Grid>
        <Grid item>
          <HeaderButton href="/next-day-delivery/" size="s" variant="pseudo" transparent>
            {i18n('order.header.link.delivery-to-pvz', 'Доставка до ПВЗ')}
          </HeaderButton>
        </Grid>
      </Grid>
      <Grid direction="column" container item xs>
        <Grid item xs>
          <HeaderButton size="s" variant="pseudo" active transparent>
            {i18n('order.header.link.other-cities', 'В другие города')}
          </HeaderButton>
        </Grid>

        <Grid item xs>
          <HeaderButton href="/next-day-delivery/" size="s" variant="pseudo" transparent>
            {i18n('order.header.link.courier-delivery', 'Курьерская доставка')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/next-day-delivery/" size="s" variant="pseudo" transparent>
            {i18n('order.header.link.delivery-to-pvs', 'Доставка до ПВЗ')}
          </HeaderButton>
        </Grid>
      </Grid>
    </Grid>
  ) : null
}

function SubDeliveryMenuB2BLogistic({isVisible = false}: SubMenuProps): React.ReactElement | null {
  return isVisible ? (
    <Grid direction="column" container>
      <Grid item xs>
        <HeaderButton href="/magistral/" size="s" variant="pseudo" transparent>
          {i18n('order.header.link.highways', 'Магистральные перевозки')}
        </HeaderButton>
      </Grid>
      <Grid item xs>
        <HeaderButton href="https://yandex.ru/routing/" size="s" target="_blank" variant="pseudo" transparent>
          {i18n('order.header.link.magistrals', 'Оптимизация ваших маршрутов')}
        </HeaderButton>
      </Grid>
    </Grid>
  ) : null
}

function ServicesMenu(): React.ReactElement {
  const [activeMenuItem, setActiveMenuItem] = useState<string>('delivery-to-customer')

  return (
    <Grid alignItems="flex-start" container>
      <Grid className={desktopClasses.servicesSubMenu} item>
        <Grid direction="column" container>
          <Grid
            onMouseEnter={() => {
              setActiveMenuItem('delivery-to-customer')
            }}
            item
            xs
          >
            <HeaderButton active={activeMenuItem === 'delivery-to-customer'} variant="pseudo" transparent>
              {i18n('order.header.link.delivery-to-buyer', 'Доставка до покупателя')}
            </HeaderButton>
          </Grid>
          <Grid
            onMouseEnter={() => {
              setActiveMenuItem('b2b-delivery')
            }}
            item
            xs
          >
            <HeaderButton active={activeMenuItem === 'b2b-delivery'} variant="pseudo" transparent>
              {i18n('order.header.link.b2b-delivery', 'B2B-Доставка')}
            </HeaderButton>
          </Grid>
          <Grid
            onMouseEnter={() => {
              setActiveMenuItem('restaurant-delivery')
            }}
            item
            xs
          >
            <HeaderButton
              active={activeMenuItem === 'restaurant-delivery'}
              href="/business/restaurants/"
              variant="pseudo"
              transparent
            >
              {i18n('order.header.link.restaurant-delivery', 'Доставка для ресторанов')}
            </HeaderButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs>
        <SubDeliveryMenuDeliveryToCustomer isVisible={activeMenuItem === 'delivery-to-customer'} />
        <SubDeliveryMenuB2BLogistic isVisible={activeMenuItem === 'b2b-delivery'} />
      </Grid>
    </Grid>
  )
}

export default ServicesMenu
